import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const CTABand = () => (
  <section className="bg-brand-red text-brand-cream">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-20 md:py-28 flex flex-col md:flex-row items-start md:items-center justify-between gap-10">
      <Reveal>
        <p className="eyebrow-gold">Ready when you are</p>
        <h2 className="font-display font-light text-4xl md:text-6xl leading-[1.05] mt-5">
          Importing biscuits?
          <br />
          <span className="italic">Let's talk containers.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <Link
          to="/contact"
          data-testid="cta-band-button"
          className="group inline-flex items-center gap-3 rounded-full bg-brand-cream px-8 py-4 text-sm font-bold text-brand-choc transition-all duration-300 hover:bg-brand-choc hover:text-brand-cream"
        >
          Talk to the export desk
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </Reveal>
    </div>
  </section>
);

export default CTABand;
